// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeaderContainer_root__O4Hzr","rootWithPadding":"PageHeaderContainer_rootWithPadding__nVIPD PageHeaderContainer_root__O4Hzr"};